let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7h0sY")).then(() => parcelRequire('jRKtE'));